
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 18 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"url(#linear_gradient_1)","d":"M1.12 4.64a.673.673 0 0 1 .507-1.115h9.631q.134 0 .256.05L5.84 9.915z"}}),_c('path',{attrs:{"fill":"url(#linear_gradient_2)","d":"M11.267 16.306h-9.65a.673.673 0 0 1-.491-1.121l10.388-11.61a.7.7 0 0 1 .245.174l5.116 5.718a.673.673 0 0 1 .005.892l-5.125 5.728a.67.67 0 0 1-.488.22"}}),_c('path',{attrs:{"fill":"url(#linear_gradient_3)","d":"M14.418 6.72 5.84 16.306H1.618a.673.673 0 0 1-.492-1.121l10.388-11.61a.7.7 0 0 1 .245.174z"}}),_c('defs',[_c('linearGradient',{staticClass:"i-linear_gradient_1",attrs:{"x1":"8.195","x2":"5.841","y1":"11.093","y2":"3.525","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#0D36A5"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#1152D4"}})]),_c('linearGradient',{staticClass:"i-linear_gradient_2",attrs:{"x1":"8.7","x2":"8.7","y1":"3.525","y2":"16.306","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#84CAFF"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#61B1FB"}})]),_c('linearGradient',{staticClass:"i-linear_gradient_3",attrs:{"x1":"7.27","x2":"7.27","y1":"3.525","y2":"16.306","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#3B90F5"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#2A78EE"}})])])])
          )
        }
      }
    